import { has } from 'lodash';

/**
 * This function is used on the US, GB, and DE decision/declined pages to get
 * "dynamic" keys from our propery files. The "dynamic" portion of the messages
 * are the "applicationStatus" and the "keySuffix". We need to make sure that
 * we don't show "blank" pages, so you should ensure that the applicationStatus
 * and keySuffix you pass in are valid.
 *
 * @param {*} intl the 'react-intl' object injected via injectIntl
 * @param {*} messages the messages map from our redux store
 * @param {*} localePrefix the property file LOCALE_PREFIX
 * @param {*} applicationStatus the current application status
 * @param {*} merchantName the merchantName from our redux store
 * @returns {function} returns a function that can be called with a key and keySuffix
 */
const createDecisionPageGetter = (intl, messages, localePrefix, applicationStatus, merchantName) => (key, keySuffix) => {
    let id = `${localePrefix}.${applicationStatus}.${key}`;
    const idWithSuffix = `${id}${keySuffix}`;
    if (keySuffix && has(messages, idWithSuffix)) {
        id = idWithSuffix;
    }
    
    return intl.formatMessage(
        { id, defaultMessage: ' ' },
        {
            merchantName,
            emptySpace: ' '
        }
    );
};

export default createDecisionPageGetter;
